import request from '@/utils/workFlowRequest'
import constants from '@/utils/constants'
const WorkflowFormValueService = {
  state: {},

  mutations: {},

  actions: {
    /**
     * 提交的表单数据分页
     */
    workflowFormValuePage({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get(constants.WORKFLOW + 'workflowFormValue/page', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
    * 根据主键获得提交的表单数据
    */
    workflowFormValueGetById({ commit }, id) {
      return new Promise((resolve, reject) => {
        request.get(constants.WORKFLOW + 'workflowFormValue/getById/' + id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
    * 根据主键获得提交的表单数据详情
    */
    workflowFormValueGetDetailsById({ commit }, id) {
      return new Promise((resolve, reject) => {
        request.get(constants.WORKFLOW + 'workflowFormValue/getDetailsById/' + id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 提交的表单数据保存
     */
    workflowFormValueSave({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.WORKFLOW + 'workflowFormValue/save', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 提交的表单数据更新
     */
    workflowFormValueUpdate({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.WORKFLOW + 'workflowFormValue/update/' + params.id, params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 提交的表单数据删除
     */
    workflowFormValueRemove({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.WORKFLOW + 'workflowFormValue/remove', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default WorkflowFormValueService
